export default {
  common: {
    attention: 'Attention',
    error: 'Erreur',
    success: 'Succès',
    continue: 'Continuer',
    understood: 'Compris !',
    backToLogin: 'Retour à la connexion',
    please: 'Veuillez :',
  },
  login: {
    password: 'Mot de passe',
    cpf: 'CPF',
    email: 'E-mail',
    loginWith: 'Se connecter avec :',
    logWith: 'Se connecter avec :',
    forgotPassword: 'Mot de passe oublié ?',
    noAccount: 'Pas de compte ?',
    noAccountYet: 'Pas encore de compte ?',
    switchToEmail: 'Basculer vers l\'e-mail',
    switchToCpf: 'Basculer vers le CPF',
    register: 'Inscrivez-vous',
    createAccount: 'Créer un compte',
  },
  recover: {
    title: 'Récupérez votre mot de passe',
    titleConfirm: 'Récupération du mot de passe',
    instructionEmail: 'Entrez votre e-mail pour récupérer votre compte.',
    instructionCpf: 'Entrez votre CPF pour récupérer votre compte.',
    instructionEmailPassword: 'Entrez votre e-mail pour récupérer votre mot de passe.',
    instructionCpfPassword: 'Entrez votre CPF pour récupérer votre mot de passe.',
    submit: 'Récupérer',
    back: 'Retour',
    incompleteData: 'Données incomplètes',
    fillField: 'Veuillez remplir le champ ci-dessous.',
    submitError: 'Erreur lors de l\'envoi de la demande',
    successMessage:
      'Si tout est correct, un e-mail de réinitialisation du mot de passe sera envoyé à l\'adresse enregistrée.',
  },
  cadastro: {
    iAgreeWith: "J'accepte les",
    termsOfUse: "Conditions d'utilisation et la politique de confidentialité",
    fromThisSite: 'de ce site.',
    acceptTermsPrivacy:
      "Acceptez les conditions d'utilisation et la politique de confidentialité",
    termsOfUsePrivacy: "Conditions d'utilisation et politique de confidentialité",
    requiredField: 'Obligatoire',
    optinLoadError:
      'Revenez et réessayez, ou contactez le support. L\'erreur suivante s\'est produite : {error}',
    waitRegisteringYourAccount:
      'Veuillez patienter, nous enregistrons votre compte. Cela peut prendre quelques secondes.',
    accountCreationMessage: 'Inscription effectuée avec succès !',
    accountCreationMessageError: 'Impossible de créer votre compte.',
    accountCreationMessageNetworkError:
      'Erreur réseau : vérifiez votre connexion Internet.',
    requiredTerms: 'Vous devez accepter toutes les conditions obligatoires.',
    requiredTermsTitle: 'Conditions obligatoires',
    cannotContinue: "Impossible de continuer l'inscription.",
    confirmYourData: 'Veuillez confirmer vos informations.',
  },
  cpfVerification: {
    placeholder: 'Entrez votre CPF',
    notInBrazil: 'Je ne vis pas au Brésil',
    cpfEmailAssociated:
      'Votre CPF et votre e-mail sont déjà associés à un compte.<br />Pour continuer, entrez le code de vérification envoyé à l\'e-mail enregistré.',
    verificationCodePlaceholder: 'Entrez le code de vérification reçu',
    cpfRequired: 'Vous devez indiquer votre CPF.',
    cpfInvalid: 'Veuillez entrer un CPF valide.',
  },
  nationality: {
    label: 'Quelle est votre nationalité ?',
    loadError: 'Le chargement de la liste des pays a échoué.',
    required: 'Veuillez renseigner votre nationalité.',
  },
  country: {
    label: 'Dans quel pays résidez-vous ?',
    loadError: 'Le chargement de la liste des pays a échoué.',
    required: 'Veuillez renseigner votre pays de résidence.',
  },
  passport: {
    placeholder: 'Passeport',
    required: 'Vous devez indiquer le passeport.',
    invalid: 'Veuillez entrer un passeport valide.',
  },
  birthDate: {
    placeholder: 'Date de naissance (jj/mm/aaaa)',
    required: 'Vous devez indiquer votre date de naissance.',
    invalid: 'Veuillez entrer une date de naissance valide.',
    minimumAge: 'Inscription autorisée uniquement pour les personnes de plus de {age} ans.',
  },
  gender: {
    identity: 'Identité de genre',
    male: 'Masculin',
    female: 'Féminin',
    other: 'Autre',
    required: 'Vous devez indiquer votre genre.',
  },
  name: {
    firstName: 'Prénom',
    fullName: 'Nom complet',
    surname: 'Nom de famille',
    fullNameRequired: 'Vous devez indiquer votre nom complet.',
    firstNameRequired: 'Vous devez indiquer votre prénom.',
    surnameRequired: 'Vous devez indiquer votre nom de famille.',
    socialNameRequired: 'Vous devez indiquer comment vous souhaitez être appelé(e).',
    beCalled: 'Comment souhaitez-vous être appelé(e) ?',
  },
  cpfAndPhone: {
    cpfInvalid: 'Veuillez entrer un CPF valide.',
    phoneRequired: 'Vous devez indiquer un numéro de téléphone.',
    phoneInvalid: 'Veuillez entrer un numéro de téléphone valide.',
    phoneInternationalInvalid: 'Veuillez entrer un numéro de téléphone international valide.',
  },
  email: {
    placeholder: 'E-mail',
    confirmPlaceholder: 'Confirmez votre e-mail',
    verificationCode: 'Entrez le code de vérification reçu',
    verificationCodeInput: 'Entrez le code de vérification',
    codeSent: 'Un code a été envoyé à votre e-mail !',
    codeSentToast: 'Un code a été envoyé à votre e-mail ! {email}',
    notMandatory: '*Non obligatoire',
    mandatory: '*Obligatoire',
    required: 'Vous devez indiquer un e-mail.',
    invalid: 'Veuillez entrer un e-mail valide.',
    mismatch: 'Les e-mails indiqués sont différents.',
    codeRequired: 'Vous devez indiquer le code de vérification.',
    codeInvalid: 'Le code saisi est incorrect.',
    unknownVerificationError: "Erreur inconnue lors de la vérification de l'e-mail.",
  },
  phone: {
    mobile: 'Téléphone portable',
    ddi: 'Indicatif*',
    ddiExample: 'ex: 33',
    areaCode: 'Indicatif régional*',
    yourPhone: 'Votre téléphone*',
    number: 'numéro',
    required: 'Vous devez indiquer un numéro de téléphone.',
    invalid: 'Veuillez entrer un numéro de téléphone valide.',
    loadingCountries: 'Chargement...',
  },
  password: {
    password: 'Mot de passe',
    repeatPassword: 'Répéter le mot de passe',
    minimumCharacterPass: 'Au moins 8 caractères.',
    specialCharacter: 'Au moins 1 caractère spécial.',
    oneNumber: 'Au moins 1 chiffre.',
    requiredPass: 'Un mot de passe est requis.',
    minimumCharacterPassError: 'Le mot de passe doit contenir au moins 8 caractères.',
    specialCharacterError: 'Le mot de passe doit contenir au moins 1 caractère spécial.',
    oneNumberError: 'Le mot de passe doit contenir au moins 1 chiffre.',
    differentPass: 'Les mots de passe indiqués sont différents.',
  },
  cep: {
    cep: 'CODE POSTAL',
    city: 'VILLE',
    address: 'ADRESSE',
    neighborhood: 'QUARTIER',
    state: 'ÉTAT',
    stateHint: 'Forme abrégée uniquement (max. 4 caractères)',
    number: 'Nº',
    complement: 'COMPLÉMENT',
    cepRequired: 'Vous devez indiquer un code postal.',
    numberRequired: 'Vous devez indiquer un numéro.',
    onlyNumber: 'Le Nº ne doit contenir que des chiffres.',
    addressRequired: 'Vous devez indiquer la localité et l\'adresse.',
    neighborhoodRequired: 'Vous devez indiquer un quartier.',
    stateRequired: 'Vous devez indiquer un état.',
  },
  guardian: {
    introLine1: 'Les mineurs de moins de 16 ans doivent inscrire',
    introLine2: 'un responsable légal.',
    fullName: 'Nom complet du responsable',
    genderLabel: 'Genre du responsable',
    mandatory: '*Obligatoire',
    firstName: 'Prénom du responsable',
    surname: 'Nom de famille du responsable',
    cpf: 'CPF du responsable',
    email: 'E-mail du responsable',
    birthDate: 'Date de naissance du responsable',
    phone: 'Téléphone portable du responsable',
    degree: 'Lien de parenté',
    verificationCode: 'Entrez le code de vérification',
    codeSent: 'Un code a été envoyé à l\'e-mail du responsable !',
    firstNameRequired: 'Vous devez indiquer le nom du responsable.',
    surnameRequired: 'Vous devez indiquer le nom de famille.',
    cpfInvalid: 'Veuillez entrer un CPF valide.',
    phoneRequired: 'Vous devez indiquer un numéro de téléphone.',
    phoneInvalid: 'Veuillez entrer un numéro de téléphone valide.',
    genderRequired: 'Vous devez indiquer le genre.',
    degreeRequired: 'Vous devez indiquer le lien de parenté.',
    birthDateInvalid: 'Veuillez entrer une date de naissance valide pour le responsable.',
    ageRequired: 'Le responsable doit être majeur (plus de 18 ans).',
    emailInvalid: 'Un e-mail valide est requis.',
    codeInvalid: 'Le code saisi est incorrect.',
  },
  searchUser: {
    searchPrompt: 'Rechercher le responsable par CPF ou e-mail.',
    searchPromptEmailOnly: 'Rechercher le responsable par e-mail.',
    search: 'Rechercher',
    searching: 'Recherche en cours...',
    cpfOrEmail: 'CPF ou E-mail',
    emailOnly: 'E-mail',
    guardianName: 'Nom du responsable',
    guardianRequired: 'Vous devez indiquer un responsable.',
    cpfRequired: 'Pour rechercher le responsable, saisissez le CPF (11 chiffres).',
    cpfOrEmailInvalid: 'Veuillez saisir un CPF valide (11 chiffres) ou un e-mail valide.',
    emailRequired: 'Pour rechercher le responsable, saisissez un e-mail valide.',
    invalidAccountTitle: 'OUPS, COMPTE NON TROUVÉ !',
    invalidAccountMessageEmail:
      'Nous n\'avons pas trouvé de compte associé à l\'e-mail saisi. Vérifiez l\'adresse ou inscrivez un responsable.',
    invalidAccountMessageCpf:
      'Nous n\'avons pas trouvé de compte associé au CPF saisi. Vérifiez le numéro ou inscrivez un responsable.',
    emailEntered: 'E-mail saisi :',
    cpfEntered: 'CPF saisi :',
    tryAgain: 'Réessayer',
    registerGuardian: 'Inscrire un responsable',
  },
  foreignUnder18: {
    title: 'ATTENTION',
    message:
      'L\'inscription des mineurs en tant qu\'étrangers n\'est pas autorisée. Contactez le support à contato@galonaveia.com.br pour plus d\'informations.',
  },
  frenchAddress: {
    streetName: 'Nom de la rue*',
    houseNumber: 'Numéro*',
    addressLine2: 'Complément d\'adresse',
    postalCode: 'Code postal*',
    city: 'Ville*',
    stateRegion: 'Région / État',
    stateRegionPlaceholder: 'Région / État',
    country: 'Pays*',
    streetNameRequired: 'Vous devez indiquer le nom de la rue.',
    houseNumberRequired: 'Vous devez indiquer le numéro.',
    postalCodeRequired: 'Vous devez indiquer le code postal.',
    cityRequired: 'Vous devez indiquer la ville.',
    countryRequired: 'Vous devez indiquer le pays.',
  },
}
